import {
    QueryFunction,
    QueryKey,
    useQuery,
    UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { DashboardApiService } from 'features/dashboard/api/dashboard-api.services';
import {
    EventsResponse,
} from 'features/events/api/events-api.service';

import { dashboardQueryKeys } from './query-keys';



const { getDashBoardregistrationdemographic } = DashboardApiService();

const getDashboardQuery = (
    params: any,
    options?: UseQueryOptions<any>,
): {
    queryKey: QueryKey;
    queryFn: QueryFunction<EventsResponse>;
    options?: UseQueryOptions<EventsResponse>;
} => ({
    queryKey: dashboardQueryKeys.list(params),
    queryFn: ({ signal }) => getDashBoardregistrationdemographic(params, { config: { signal } }),
    ...options,
});

export const useGetDashboardDemographic = (
    params: any,
    options?: UseQueryOptions<any>,
) => {
    const { message } = App.useApp();

    return useQuery<any, Error>(
        getDashboardQuery(params, {
            onError: (error: unknown) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            ...options,
        }),
    );
};

